import MediaFormatsInputModal, {
  MediaFormatsInputModalPropsBase,
} from "@/components/modal/media-formats-input-modal/media-formats-input-modal";
import ConvertBaseSettingsDropDown from "@/components/common/convert-base/convert-base-settings-drop-down";
import React, { useState } from "react";
import {
  DuetsContextState,
  useDuetsContext,
} from "@/components/pages/duets/providers/duets-provider";

export interface DuetConfigModalProps
  extends Omit<MediaFormatsInputModalPropsBase, "onClick"> {
  onClick: (songFile: File | null, config: DuetsContextState) => void;
}

const DuetConfigModal = (props: DuetConfigModalProps) => {
  const [isSettingsOpen, setIsSettingsOpen] = useState(true);

  const context = useDuetsContext();

  return (
    <MediaFormatsInputModal
      {...props}
      onClick={(file) => props.onClick(file, context)}
    >
      <ConvertBaseSettingsDropDown
        isOpen={isSettingsOpen}
        setIsOpen={setIsSettingsOpen}
        context={context}
      />
    </MediaFormatsInputModal>
  );
};

export default DuetConfigModal;
